(function ($) {
	class W4D_Povrati {
		shouldLoadRegex = /^\/(povrat(?:i-portal|-posalji)?|zamjena(?:-posalji)?|reklamacija(?:-posalji)?|narudzba)(\/|$)/;

		constructor() {
			if (!this.shouldLoad(this.shouldLoadRegex)) {
				return;
			}

			this.originalState = {};
			this.currentState = {};

			this.initSelectors();
			this.bindEvents();
			this.getReturnsStorageKey();
			this.restoreSummaryFromLocalStorage();
			this.captureOriginalState();
			this.updateConfirmChoiceButton();
		}

		shouldLoad(shouldLoadRegex) {
			return shouldLoadRegex.test(window.location.pathname);
		}

		initSelectors() {
			this.$povratiAside = $('.povrati__aside');
			this.$povratiBtn = $('[data-js-povrati-options-btn]');
			this.$confirmChoiceBtn = $('[data-js-confirm-choice-btn]');
			this.$productList = $('.product-list');
			this.$orderSummaryCloseBtn = $('[data-js-order-summary-close]');
			this.orderSummaryProductList = $('.order-summary .product-list');
			this.$povratiCard = $('.card--povrat');
			this.$form = $('#returns__form');
			this.$sendRequestBtn = this.$form.find('button[type="submit"]');
			this.returnsFindOrderForm = $('#returns-find-order');
			this.$returnsFindOrderBtn = this.returnsFindOrderForm.find('button[type="submit"]');
			this.$openOrderSummaryBtn = $('[data-js-open-order-summary]');
			this.nextStepBtn = $('[data-js-next-step-link]');
			this.$reklamacijaItemList = $('#returns-item-list');
			this.$orderSummary = $('.order-summary');
			this.$orderSummaryHeaderCloseBtn = this.$povratiAside.find('.order-summary__header .icon-x').parent();
			this.$main = $('main');
		}

		bindEvents() {
			this.$povratiBtn.on('click', (e) => this.handlePovratiOptionsBtnClick(e));
			this.$productList.on('input', '.product-custom-quantity .field__input, .product-quantity input', (e) =>
				this.handleProductQuantityChange(e)
			);
			this.$povratiCard.on('click', (e) => this.handlePovratiCardClick(e));
			this.$openOrderSummaryBtn.on('click', () => this.toggleOrderSummary());
			this.$orderSummaryHeaderCloseBtn.on('click', () => this.closeOrderSummary());
			this.$main.on('click', (e) => {
				if (this.isMobileViewport && this.$povratiAside.attr('aria-hidden') === 'false') {
					if ($(e.target).is(this.$main)) {
						this.closeOrderSummary();
					}
				}
			});

			this.$productList.on('change', '.variations input[type="radio"]', (e) => this.handleVariationChange());
			this.$productList.on('change', '.variations select', (e) => this.handleVariationChange());

			const currentUrl = window.location.href;

			// Check if "-posalji" appears before "/?" or "?"
			const nextUrl =
				currentUrl.includes('-posalji/?') || currentUrl.includes('-posalji?')
					? currentUrl.replace('-posalji', '')
					: currentUrl.replace(/(\/?)(\?)/, '-posalji$1$2');

			this.nextStepBtn.on('click', () => {
				window.location.href = nextUrl;
			});

			this.$form.validate({
				submitHandler: (form) => {
					this.handleSubmit(form);
				},
			});

			this.$reklamacijaItemList.validate({
				highlight: function (element, errorClass, validClass) {
					$.validator.defaults.highlight.call(this, element, errorClass, validClass);
				},
				unhighlight: function (element, errorClass, validClass) {
					$.validator.defaults.unhighlight.call(this, element, errorClass, validClass);
				},
				submitHandler: () => {
					this.handleConfirmChoiceBtnClick();
				},
			});

			let validator = this.returnsFindOrderForm.validate({
				invalidHandler: function () {
					// $('#error-container').show();
				},
				success: function () {
					$('#error-container').hide();
				},
				submitHandler: () => {
					this.handleFindOrderFormSubmit(validator);
				},
			});

			this.bindViewportObserver();
		}

		toggleOrderSummary() {
			const isHidden = this.$povratiAside.attr('aria-hidden') === 'true';
			const newState = isHidden ? 'false' : 'true';

			this.$povratiAside.attr('aria-hidden', newState);
			this.updateConfirmChoiceButton();
		}

		closeOrderSummary() {
			this.$povratiAside.attr('aria-hidden', 'true');
			this.updateConfirmChoiceButton();
		}

		openOrderSummary() {
			this.$povratiAside.attr('aria-hidden', 'false');
			this.updateConfirmChoiceButton();
		}

		updateConfirmChoiceButton() {
			const $btn = this.$confirmChoiceBtn;

			// Desktop logic
			if (!this.isMobileViewport) {
				const hasChanges = this.hasStateChanged();
				const allValid = this.areChangedVariationsValid();

				$btn.prop('disabled', !(hasChanges && allValid));
				$btn.text('Potvrdi odabir');
				return;
			}

			// Mobile logic (< 1200px)
			const hasChanges = this.hasStateChanged();
			const allValid = this.areChangedVariationsValid();
			const isSummaryOpen = this.$povratiAside.attr('aria-hidden') === 'false';
			const summaryToggleText = isSummaryOpen ? 'Zatvori sažetak' : 'Prikaži sažetak';

			if (hasChanges && allValid) {
				$btn.text('Potvrdi odabir').prop('disabled', false);
			} else if (hasChanges && !allValid) {
				$btn.text('Potvrdi odabir').prop('disabled', true);
			} else {
				$btn.text(summaryToggleText).prop('disabled', false);
			}

			this.$openOrderSummaryBtn.text(summaryToggleText);
		}

		areChangedVariationsValid() {
			let allValid = true;

			this.$productList.find('> li').each((_, el) => {
				const $product = $(el);
				const qty = parseFloat($product.find('.product-custom-quantity .field__input, .product-quantity input').val()) || 0;

				// Ignore non-selected products
				if (qty <= 0) return;

				// Validate variable ones
				if (!this.isProductVariationValid($product)) {
					allValid = false;
					return false; // break loop early
				}
			});

			return allValid;
		}

		isProductVariationValid(product) {
			const $product = $(product);
			const $variations = $product.find('.variations');

			// Non-variable product → always valid
			if ($variations.length === 0) return true;

			let isValid = true;

			$variations.find('.variations__option').each((_, option) => {
				const $option = $(option);

				// radio inputs
				const $radios = $option.find('input[type="radio"]:not(:disabled)');
				if ($radios.length) {
					if ($option.find('input[type="radio"]:checked:not(:disabled)').length === 0) {
						isValid = false;
						return false; // break .each
					}
					return; // next option
				}

				// selects
				const $select = $option.find('select:not(:disabled)');
				if ($select.length) {
					const value = $select.val();
					if (!value) {
						isValid = false;
						return false;
					}
				}
			});

			return isValid;
		}

		bindViewportObserver() {
			const mq = window.matchMedia('(min-width: 1200px)');
			const onChange = () => {
				const $btn = this.$confirmChoiceBtn;

				if (!mq.matches) {
					// < 1200px (mobile)
					this.$povratiAside.attr('aria-hidden', 'true');

					// Force mobile button text and enabled state
					this.isMobileViewport = true;
					this.updateConfirmChoiceButton();
				} else {
					// >= 1200px (desktop)
					this.$povratiAside.removeAttr('aria-hidden');

					// Reset button state based on normal validation
					this.isMobileViewport = false;
					this.updateConfirmChoiceButton();
				}
			};

			if (typeof mq.addEventListener === 'function') {
				mq.addEventListener('change', onChange);
			}

			// Run initially
			onChange();
		}

		handleFindOrderFormSubmit(validator) {
			const form = this.returnsFindOrderForm[0];
			const formData = new FormData(form);

			const data = {
				email: formData.get('email')?.trim(),
				order_number: formData.get('order-number')?.trim(),
			};

			const ajaxData = {
				action: 'w4d_returns_find_order',
				nonce: w4d_frontend_ajax.nonce,
				data,
				back_url: window.location.href,
			};

			$.post({
				url: w4d_frontend_ajax.ajax_url,
				data: ajaxData,
				beforeSend: () => {
					$('#error-container').hide();
					$('#error-list').empty();
					this.$returnsFindOrderBtn.addClass('btn--loading').attr('disabled', true);
				},
				success: (response) => {
					if (response.success && response.data.redirect_url) {
						window.location.href = response.data.redirect_url;
					} else {
						W4D_FrontendHelper.showNotice('error', response.data.message);
						this.$returnsFindOrderBtn.removeClass('btn--loading').attr('disabled', false);

						if (response.data.field_errors) {
							validator.showErrors(response.data.field_errors);
						}
					}
				},
				error: (xhr) => {
					console.error(xhr);
					const errorMessage = xhr.responseJSON?.data.message || 'Došlo je do pogreške.';
					this.$returnsFindOrderBtn.removeClass('btn--loading').attr('disabled', false);
					// W4D_FrontendHelper.showNotice('error', errorMessage);

					if (xhr.responseJSON?.data.field_errors) {
						validator.showErrors(xhr.responseJSON.data.field_errors);
					} else {
						validator.showErrors({
							email: '', // prazan string ili razmak da se ne prikaže poruka
							'order-number': '',
						});

						if (errorMessage.trim() !== '') {
							$('#error-list').html(`<li>${errorMessage}</li>`);
							$('#error-container').show();
						}
					}
				},
			});
		}

		getActionType() {
			const path = window.location.pathname.replace(/\/$/, ''); // remove trailing slash
			const parts = path.split('/'); // split by slash
			const actionPart = parts[1] || 'povrat'; // get the first path segment or default

			return actionPart.split('-')[0]; // split by dash and take the first part
			// očekujemo ['', 'povrat' | 'zamjena' | 'reklamacija', …]
		}

		// --------------------------------------> Local storage methods <--------------------------------------

		getReturnsStorageKey() {
			if (!this.returnsStorageKey) {
				const action = this.getActionType();
				this.returnsStorageKey = `${action}_summary_${this.getOrderId()}`;
			}
			return this.returnsStorageKey;
		}

		loadSummaryFromLocalStorage() {
			const storageKey = this.getReturnsStorageKey();
			const stored = localStorage.getItem(storageKey);

			if (!stored) return null;

			try {
				const data = JSON.parse(stored);
				const maxAge = 24 * 60 * 60 * 1000; // 24h
				if (Date.now() - data.timestamp > maxAge) {
					localStorage.removeItem(storageKey);
					return null;
				}
				return data.summary || null;
			} catch (e) {
				console.error('Error parsing summary from Local Storage:', e);
				localStorage.removeItem(storageKey);
				return null;
			}
		}

		restoreSummaryFromLocalStorage() {
			const savedSummary = this.loadSummaryFromLocalStorage();
			if (!savedSummary) {
				this.$orderSummary.removeClass('order-summary--loading');
				return;
			}

			if (!window.location.pathname.includes('posalji')) {
				this.openOrderSummary();
			}

			// Ažuriraj order summary listu direktno iz sažetka
			this.orderSummaryProductList.html(this.generateProductRowItemHTML(savedSummary));

			savedSummary.forEach((item) => {
				const $row = this.$productList.find(`li[data-item-id="${item.itemId}"]`);
				if ($row.length) {
					const $input = $row.find('.product-custom-quantity .field__input, .product-quantity input');
					const qty = parseInt(item.quantity, 10) || 0;
					$input.val(qty);
					$row.toggleClass('is-checked', qty > 0);

					if (item.variations) {
						item.variations.forEach((variation) => {
							const $radio = $row.find('input[type="radio"]').filter(function () {
								const radioName = $(this).attr('name');
								const radioValue = $(this).val();

								// Exact name match + case-insensitive value match
								return radioName === variation.name && radioValue.toLowerCase() === variation.new_value.toLowerCase();
							});

							if ($radio.length) {
								$radio.prop('checked', true);
							} else {
								const $select = $row.find(`select[name="${variation.name}"]`);
								if ($select.length) {
									// Try normal .val() first
									$select.val(variation.new_value);

									// If not found (no change applied), match by visible text instead
									if ($select.val() !== variation.new_value) {
										const $matchByText = $select.find('option').filter(function () {
											return $(this).text().trim().toLowerCase() === variation.new_value.trim().toLowerCase();
										});

										if ($matchByText.length) {
											$select.val($matchByText.val());
										}
									}
								}
							}
						});
					}

					$row.find('.variations select, .variations input[type="radio"]:checked').trigger('change');
				}
			});

			this.nextStepBtn.prop('disabled', false);
			this.$orderSummary.removeClass('order-summary--loading');
		}

		setSummaryInLocalStorage() {
			const productSummaryList = this.getProductsData();
			const storageKey = this.getReturnsStorageKey();

			if (!Array.isArray(productSummaryList) || productSummaryList.length === 0) {
				localStorage.removeItem(storageKey);
				return;
			}

			localStorage.setItem(
				storageKey,
				JSON.stringify({
					summary: productSummaryList,
					timestamp: Date.now(),
				})
			);
		}

		clearSummaryFromLocalStorage() {
			try {
				const storageKey = this.getReturnsStorageKey();
				localStorage.removeItem(storageKey);
			} catch (e) {
				// no-op
			}
		}

		// ----------------------------------> Handlers and helpers methods <-----------------------------------
		handlePovratiCardClick(e) {
			const $card = $(e.currentTarget);

			if ($card.hasClass('card--povrat-expired')) {
				return;
			}

			const actionType = $card.data('type');
			const orderId = $card.parent().data('order-id');

			const ajaxData = {
				action: 'povrati_card_click',
				nonce: w4d_frontend_ajax.nonce,
				action_type: actionType,
				order_id: orderId,
				order_key: $card.parent().attr('data-order-key') || '',
				back_url: window.location.href,
			};

			$.post({
				url: w4d_frontend_ajax.ajax_url,
				data: ajaxData,
				success: (response) => {
					if (response.success) {
						window.location.href = response.data.redirect_url;
					} else {
						W4D_FrontendHelper.showNotice('error', response.data);
					}
				},
				error: (error) => {
					console.error('Something has gone wrong:', error);
				},
			});
		}

		handlePovratiOptionsBtnClick() {
			const povratiCardWrapper = $('[data-js-povrati-options]');
			povratiCardWrapper.toggleClass('cards--povrati-expanded');
		}

		delay(ms) {
			return new Promise((resolve) => setTimeout(resolve, ms));
		}

		handleConfirmChoiceBtnClick() {
			if (this.isMobileViewport && !this.hasStateChanged()) {
				this.toggleOrderSummary();
				return;
			}

			if (!this.isMobileViewport) {
				this.$confirmChoiceBtn.prop('disabled', true);
			}
			this.nextStepBtn.prop('disabled', false);

			this.$povratiAside.css('--transform', 'translateY(-100%)');

			const productSummaryList = this.getProductsData();

			if (productSummaryList.length === 0) {
				this.restoreEmptyState();
				if (this.isMobileViewport) {
					this.openOrderSummary();
				}
			} else {
				this.orderSummaryProductList.html(this.generateProductRowItemHTML(productSummaryList));
				this.flashSummaryChange();

				if (this.isMobileViewport) {
					this.openOrderSummary();
				}
			}

			this.captureOriginalState();
			this.setSummaryInLocalStorage();
			this.updateConfirmChoiceButton();
		}

		restoreEmptyState() {
			this.orderSummaryProductList.html('<li>Trenutno nemate dodanih stavki</li>');
			this.nextStepBtn.prop('disabled', true);
		}

		captureOriginalState() {
			this.originalState = {};

			this.$productList.find('> li').each((index, el) => {
				const $row = $(el);
				const id = $row.data('item-id') || index;

				this.originalState[id] = {
					quantity: parseFloat($row.find('.product-custom-quantity .field__input, .product-quantity input').val()) || 0,
					variations: this.getSelectedVariationValues($row),
				};
			});
		}

		getSelectedVariationValues($row) {
			const variations = {};

			$row.find('.variations input[type="radio"]:checked:not(:disabled)').each((_, input) => {
				const $input = $(input);
				variations[$input.attr('name')] = $input.val();
			});

			$row.find('.variations select:not(:disabled)').each((_, select) => {
				const $select = $(select);
				variations[$select.attr('name')] = $select.val();
			});

			return variations;
		}

		hasStateChanged() {
			let changed = false;

			this.$productList.find('> li').each((index, el) => {
				const $row = $(el);
				const id = $row.data('item-id') || index;

				const quantity = parseFloat($row.find('.product-custom-quantity .field__input, .product-quantity input').val()) || 0;
				const variations = this.getSelectedVariationValues($row);
				const original = this.originalState[id] || {};

				if (quantity !== original.quantity) {
					changed = true;
					return false; // stop loop early
				}

				const variationKeys = new Set([...Object.keys(variations), ...Object.keys(original.variations || {})]);
				for (const key of variationKeys) {
					if (variations[key] !== (original.variations || {})[key]) {
						changed = true;
						return false;
					}
				}
			});

			return changed;
		}

		getOrderId() {
			const urlParams = new URLSearchParams(window.location.search);
			const token = urlParams.get('token');
			if (!token) return 'default';

			const prefix = token.split('.')[0];
			return prefix || token;
		}

		handleProductQuantityChange(e) {
			const $input = $(e.currentTarget);

			if ($input.hasClass('input-error')) {
				return;
			}

			const productRowItem = $input.closest('li');
			const value = parseFloat($input.val()) || 0;

			productRowItem.toggleClass('is-checked', value > 0);
			this.updateConfirmChoiceButton();
		}

		handleVariationChange() {
			this.updateConfirmChoiceButton();
		}

		getProductsData() {
			const productSummaryList = [];
			const products = this.$productList.find('.is-checked');

			products.each((index, product) => {
				const $product = $(product);
				const productId = $product.data('product-id');
				const itemId = $product.data('item-id');
				const img = product.querySelector('figure img');
				const imgHTML = img.outerHTML;
				const title = $product.find('h2').text();

				// Get OLD variation values from the DL element
				const $variationDL = $product.find('.variation');
				const oldVariations = {};
				const attributes = [];

				if ($variationDL.length > 0) {
					$variationDL.find('dt').each((index, dt) => {
						const $dt = $(dt);
						const $dd = $dt.next('dd');

						if ($dd.length > 0) {
							const label = $dt.text().replace(':', '').trim();
							const value = $dd.text().trim();

							if (label && value) {
								oldVariations[label] = value;
								attributes.push(`${label}: ${value}`);
							}
						}
					});
				}

				const quantity = parseFloat($product.find('.product-custom-quantity .field__input, .product-quantity input').val());
				const unit = $product.find('.unit').text().trim();

				// Get NEW variation values from the form
				const $variationsForm = $product.find('.variations');
				const variationsArray = [];
				const selectedAttributes = {}; // For matching variation_id
				let replacementProductId = null;

				if ($variationsForm.length > 0) {
					const variationOptions = $variationsForm.find('.variations__option');

					variationOptions.each((index, option) => {
						const $option = $(option);

						// Get the label that precedes this option
						const $label = $option.prev('label');
						const attributeLabel = $label.attr('data-original-text') || $label.text().trim();

						let attributeName = '';
						let newValue = '';
						let newLabel = '';

						// Radio buttons - get checked and NOT disabled
						const radioInput = $option.find('input[type="radio"]:checked');

						if (radioInput.length > 0) {
							let rawAttributeName = radioInput.attr('name');

							let cleanAttributeName = rawAttributeName.replace(/_item_\d+$/, '');
							attributeName = rawAttributeName;

							newValue = radioInput.val();
							newLabel = radioInput.siblings('label').attr('title') || radioInput.val();

							// Store for variation_id matching
							selectedAttributes[cleanAttributeName] = newValue;
						}

						const selectInput = $option.find('select:not(:disabled)');
						if (selectInput.length > 0) {
							const selectedValue = selectInput.val();
							if (selectedValue && selectedValue !== '') {
								let rawAttributeName = selectInput.attr('name');
								let cleanAttributeName = rawAttributeName.replace(/_item_\d+$/, '');
								attributeName = rawAttributeName;

								newValue = selectedValue;
								const selectedOption = selectInput.find('option:selected');
								newLabel = selectedOption.text();

								// Store for variation_id matching
								selectedAttributes[cleanAttributeName] = selectedValue;
							}
						}

						// Only add to display array if we have a new value selected
						if (attributeName && newValue) {
							variationsArray.push({
								label: attributeLabel,
								old_value: oldVariations[attributeLabel] || '',
								new_value: newLabel,
								name: attributeName,
							});
						}
					});

					// Find the matching variation_id from JSON data
					const variationsContainer = $product.find('.variations_container');
					if (variationsContainer.length > 0 && Object.keys(selectedAttributes).length > 0) {
						try {
							const productVariations = JSON.parse(variationsContainer.attr('data-product_variations'));

							// Find matching variation
							const matchingVariation = productVariations.find((variation) => {
								const variationAttrs = variation.attributes;

								// Check if all selected attributes match
								return Object.keys(selectedAttributes).every((attrKey) => {
									const selectedVal = selectedAttributes[attrKey];
									const variationVal = variationAttrs[attrKey];

									// Handle empty string in variation (means "Any")
									return variationVal === '' || variationVal === selectedVal;
								});
							});

							replacementProductId = matchingVariation ? matchingVariation.variation_id : null;
						} catch (e) {
							console.error('Error parsing product variations:', e);
						}
					}
				}

				productSummaryList.push({
					productId,
					itemId,
					img: imgHTML,
					title,
					attributes,
					quantity,
					unit,
					...(variationsArray.length > 0 && {
						variations: variationsArray,
						replacement_product_id: replacementProductId,
					}),
				});
			});

			return productSummaryList;
		}

		flashSummaryChange() {
			this.orderSummaryProductList.addClass('product-list--changed');
			setTimeout(() => {
				this.orderSummaryProductList.removeClass('product-list--changed');
			}, 200);
		}

		generateProductRowItemHTML(products) {
			return products
				.map((product) => {
					let attributesHTML = '';
					let variationHTML = '';

					if (product.attributes.length > 0) {
						attributesHTML = `
                    <ul class="product-attribute-list">
                        ${product.attributes
							.map(
								(attr) => `
                            <li class="product-attribute">${attr}</li>
                        `
							)
							.join('')}
                    </ul>`;
					}

					if (product.variations && product.variations.length > 0) {
						// Clone the template
						const $template = $('#product-row-item-variation-template');
						const $variationsList = $($template.prop('content')).find('.product-variations-list').clone();

						// Get and remove the template li
						const $liTemplate = $variationsList.find('.product-variation').clone();
						$variationsList.empty();

						// Create a li for each variation
						product.variations.forEach((variation) => {
							const $variationItem = $liTemplate.clone();
							$variationItem.find('.product-variation-label').text(`${variation.label}: ${variation.old_value}`);
							$variationItem.find('.product-variation-new').text(variation.new_value);
							$variationsList.append($variationItem);
						});

						// Get the outer HTML
						variationHTML = $('<div>').append($variationsList).html();
					}

					return `
                <li data-product-id="${product.productId}">
                    <article>
                        <figure>
                            ${product.img}
                        </figure>
                        <div class="product-details">
                            <h2>${product.title}</h2>
                            ${attributesHTML}
                            ${variationHTML}
                        </div>
                        <div>${product.quantity} ${product.unit}</div>
                    </article>
                </li>`;
				})
				.join('');
		}

		handleSubmit(form) {
			const fd = new FormData();

			fd.append('action', 'w4d_povrati_submit');
			fd.append('nonce', w4d_frontend_ajax.nonce);
			fd.append('action_type', this.getActionType());

			const rawFormData = new FormData(form);
			const formData = {};

			for (const [key, value] of rawFormData.entries()) {
				if (key === 'reklamacija-reason[]') continue;
				if (formData[key] !== undefined) {
					if (!Array.isArray(formData[key])) formData[key] = [formData[key]];
					formData[key].push(value);
				} else {
					formData[key] = value;
				}
			}

			function getLabelText(input) {
				const label = (input.labels && input.labels[0]) || input.closest('label');
				return label ? label.innerText.trim().replace(/\s+/g, ' ') : input.value;
			}

			const reasonInputs = form.querySelectorAll('input[name="reklamacija-reason[]"]:checked');
			formData['reasons'] = Array.from(reasonInputs).map(getLabelText);
			delete formData['reklamacija-uploads'];

			formData.gdpr = rawFormData.has('gdpr') ? 1 : 0;

			const urlParams = new URLSearchParams(window.location.search);
			const token = urlParams.get('token') ?? '';
			const savedSummary = this.loadSummaryFromLocalStorage();

			const items = [];
			savedSummary.forEach((item) => {
				items.push({
					product_id: item.productId,
					quantity: parseFloat(item.quantity) || 0,
					...(item.replacement_product_id && { replacement_product_id: item.replacement_product_id }),
				});
			});

			fd.append('token', token);
			fd.append('form_data', JSON.stringify(formData));
			fd.append('items', JSON.stringify(items));

			// Attachments[]
			$(form)
				.find('input[type="file"]')
				.each(function () {
					const files = window.W4D_FileStore.get(this) || [];
					files.forEach((file) => {
						// treći argument čuva originalni naziv
						fd.append('attachments[]', file, file.name);
					});
				});

			$.post({
				url: w4d_frontend_ajax.ajax_url,
				data: fd,
				processData: false,
				contentType: false,
				beforeSend: () => {
					this.$sendRequestBtn.addClass('btn--loading').attr('disabled', true);
				},
				success: (response) => {
					if (response.success) {
						this.clearSummaryFromLocalStorage();
						window.location.href = response.data;
					} else {
						this.$sendRequestBtn.removeClass('btn--loading').attr('disabled', false);
						W4D_FrontendHelper.showNotice('error', response.data);
					}
				},
				error: (error) => {
					this.$sendRequestBtn.removeClass('btn--loading').attr('disabled', false);
					console.error('Something has gone wrong. Check error_log.', error);
				},
			});
		}
	}

	$(document).ready(() => {
		new W4D_Povrati();
	});
})(jQuery);
